import * as React from 'react';
import * as Styled from './styled';
import { AEMContent, Card, Grid } from '@mlc/web-ui-toolkit';
import palette from '@mlc/mlc-palette';

class Footer extends React.Component {
	public render() {
		return (
			<Card backgroundColor={palette.mlcText} paddingTop={2} paddingBottom={2}>
				<Grid>
					<Styled.Disclaimer>
						<AEMContent path="/secure/_content/common/_footer-disclaimer" />
					</Styled.Disclaimer>
				</Grid>
			</Card>
		);
	}
}

export default Footer;
